export const PLATFORMS = new Map([
  ["SweetTV", ["sweet.tv"]],
  ["YouTV", []],
  ["ProstoTV", []]
]);

